export default __webpack_public_path__ + "static/media/Image-7.386d1bc0.png";